import '@Pages/pageRuntime/sourceRuntime';
import {
  loadAuthoringRuntime,
  rendersAuthoringSource
} from '@Pages/pages/showPage/authoringRuntime';
import {
  PageLayout,
  ShowPageContent,
  type ShowPageProps
} from '@Pages/pages/showPage/ShowPageContent';
import { lazy, Suspense, type ComponentProps, type ReactNode } from 'react';

/**
 * A page rendered from source: a row-based page, a draft preview, or a page
 * of a deployment without browser modules. It compiles the source.
 */
function ShowPage(props: ShowPageProps) {
  return <ShowPageContent {...props} />;
}

function AuthoringRuntimeLoaded({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

const AuthoringRuntime = lazy(async () => {
  await loadAuthoringRuntime();

  return { default: AuthoringRuntimeLoaded };
});

function ShowPageLayout(props: ComponentProps<typeof PageLayout>) {
  if (!rendersAuthoringSource(props)) {
    return <PageLayout {...props} />;
  }

  return (
    <Suspense fallback={null}>
      <AuthoringRuntime>
        <PageLayout {...props} />
      </AuthoringRuntime>
    </Suspense>
  );
}

ShowPage.layout = ShowPageLayout;

export default ShowPage;
